
export default `
Our refund policy is simple. If you have download the ebook but not opened the file in an ebook reader, we can provide a 100% refund. If you have already opened the ebook, we can not provide a refund as there is no way of revoking your access to the download after opening an ebook.
`.trim();